<template>
  <q-card
    style="height: 80vh;width:30vw;max-width: 500px"
    class="column no-wrap q-pa-md"
    v-if="sample"
  >
    <q-card-section class="col-grow column">
      <header class="text-bold " style="font-size: 1.3rem">
        将样本移动至其他分组
      </header>
      <p class="q-pb-md text-primary text-caption">
        {{ sample.detail.name }}
      </p>
      <q-scroll-area class="col-grow column">
        <q-list>
          <q-item
            v-for="group in groupList"
            :key="group.id"
            :clickable="groupId !== group.id"
            dense
            class="row items-center q-mb-sm"
            style="height: 36px"
            :class="{
              'tlan-move-sample-item-checked': checked == group.id,
              'tlan-move-sample-item-disabled': groupId == group.id,
            }"
            @click="checked = group.id"
          >
            {{ group.name }}
            <span v-if="groupId === group.id">（当前样本组）</span>
          </q-item>
        </q-list>
      </q-scroll-area>
    </q-card-section>

    <q-card-actions class="row justify-end q-pt-md">
      <q-btn outline color="primary" @click="$emit('cancel')">
        取消
      </q-btn>
      <q-btn
        flat
        class="text-white bg-primary"
        :disable="!checked"
        @click="moveSampleToAnotherGroup(checked)"
      >
        确认
      </q-btn>
    </q-card-actions>
  </q-card>
</template>

<script>
import { getSampleGroupList } from "@/api/endpoints/sample-group/getSampleGroupList";
import { updateSampleGroupSamples } from "@/api/endpoints/sample-group/updateSampleGroupSamples";
export default {
  props: {
    groupId: {
      type: String,
    },
    sample: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      groupList: [],
      checked: null,
    };
  },

  mounted() {
    console.log(this.sample);
    this.getGroupList();
  },

  methods: {
    async getGroupList() {
      try {
        const res = await getSampleGroupList();
        if (res.status || res.error) throw Error(res.detail || res.message);
        this.groupList = res;
      } catch (err) {
        this.$q.notify({ type: "danger", message: err.toString() });
      }
    },

    async moveSampleToAnotherGroup(newGroupId) {
      const { sample } = this;
      try {
        const res = await updateSampleGroupSamples(newGroupId, {
          append: [sample.id],
        });
        if (res.status || res.error) throw Error(res.detail || res.message);
        this.$emit("updated");
      } catch (err) {}
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

.tlan-move-sample-item-checked {
  background-color: rgba($primary, 0.1);
  color: $primary;
}
.tlan-move-sample-item-disabled {
  color: $grey !important;
  cursor: not-allowed;
}
</style>
